import { render, staticRenderFns } from "./LKMunMehReviewForm.vue?vue&type=template&id=527f54b5&"
import script from "./LKMunMehReviewForm.vue?vue&type=script&lang=js&"
export * from "./LKMunMehReviewForm.vue?vue&type=script&lang=js&"
import style0 from "./LKMunMehReviewForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VSkeletonLoader,VTabItem,VTabsItems})
